// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"f7d919dd","418":"668b9d06","668":"7502b725"}[chunkId] + ".js";
};